import { LINKS } from './constant';

export const buildPdpLink = (catalogNumber: string, query?) => {
  if (!catalogNumber) return '';
  let queryParams = '';
  const encodedCatalogNumber = encodeURIComponent(catalogNumber || '');
  if (query) {
    queryParams = `?${new URLSearchParams(query)}`;
  }
  return `/product/${encodedCatalogNumber}${queryParams}`;
};

export const buildCSRPdpLink = (catalogNumber: string) => {
  const encodedCatalogNumber = encodeURIComponent(catalogNumber || '');
  return `${LINKS.homepage}/apac/product/${encodedCatalogNumber}`;
};

export const decodePdpLink = (catalogNumber: string) => {
  return decodeURIComponent(catalogNumber || '');
};

export const createGptNumberLink = (gptNumber: string) => {
  return `/search/category/${gptNumber}`;
};
